// extracted by css-extract-rspack-plugin
export default {"label":"label-o_1ZZ3","checked":"checked-T06P1F","checkDot":"checkDot-Gzid6x","empty":"empty-v899kS","disabled":"disabled-y_Ent7"};